export default __webpack_public_path__ + "static/media/auditai1.e85241c9.png";